import { FC } from 'react'
import { 
    FirmViewHeaderContainer,
 } from '../index'
 import { TbMail } from 'react-icons/tb'

interface FirmHeaderProps {
    firmName: string;
    firmNumber: string;
    email: string;
}
 
const FirmHeader: FC<FirmHeaderProps> = ({
    firmName,
    firmNumber,
    email
}) => {
    return (
        <FirmViewHeaderContainer>
            <aside>
                <h1>{firmName}</h1>
                <h2>Firm #{firmNumber}</h2>
            </aside>
            <div>
                <a href={`mailto:${email}`}>
                    <TbMail />
                    Contact Firm
                </a>   
            </div>
        </FirmViewHeaderContainer>
    )
}

export default FirmHeader